import { useLoaderData, useLocation } from 'react-router';

import { useProfessionalInitialRouteData } from '@modules/professional/hook/use-professional-initial-route-data';
import type { LocationState } from '@modules/professional/page/InfoPage';
import { Info } from '@modules/professional/component/about-tab/info/Info';
import { Award } from '@modules/professional/component/about-tab/awards/Awards';
import { TeamMembers } from '@modules/professional/component/about-tab/team-member/TeamMembers';
import { CompanyImages } from '@modules/professional/component/about-tab/company-images/CompanyImages';
import { Testimonials } from '@modules/professional/component/about-tab/testimonial/Testimonials';
import PageSections from '@modules/professional/component/page-layout/PageSections';
import type { InfoPageLoaderData } from '@modules/professional/api/info-page-loader.server';
import { Grid, pxToRem, useStyles } from '@archipro-design/aria';

const InfoPageMobile = () => {
    const location = useLocation();
    const locationState = location.state as LocationState;
    const defaultClamped = locationState?.clamped;
    const { Banners } = useProfessionalInitialRouteData();
    const { css } = useStyles();
    const {
        companyImageResult,
        professionalTestimonials: testimonials,
        teamMembersResult,
        awardsResult,
    } = useLoaderData<InfoPageLoaderData>();

    const companyImages = companyImageResult?.companyImages ?? [];
    const countRemaining = companyImageResult?.countRemaining ?? 0;
    const imagePlacement = companyImageResult?.imagePlacement ?? [];
    const isLastImageLandscape =
        companyImageResult?.isLastImageLandscape ?? false;
    const isPortraitOnly = companyImageResult?.isPortraitOnly ?? false;

    return (
        <PageSections>
            <Grid
                columns={1}
                className={css({
                    gridGap: pxToRem(60),
                })}
            >
                <Info defaultClamped={defaultClamped} banners={Banners} />
                {awardsResult.awards.length ? (
                    <Award pageInfo={awardsResult.pageInfo} />
                ) : null}
                {teamMembersResult?.teamMembers.length ? (
                    <TeamMembers
                        {...teamMembersResult}
                        sectionTitle="Meet the team"
                    />
                ) : null}
                <Grid
                    columns={1}
                    className={css({
                        gridGap: pxToRem(30),
                    })}
                >
                    {companyImages.length > 0 && (
                        <CompanyImages
                            companyImages={companyImages}
                            countRemaining={countRemaining}
                            imagePlacement={imagePlacement}
                            isLastImageLandscape={isLastImageLandscape}
                            isPortraitOnly={isPortraitOnly}
                        />
                    )}
                    {testimonials.length ? (
                        <Testimonials testimonials={testimonials} />
                    ) : null}
                </Grid>
            </Grid>
        </PageSections>
    );
};

export default InfoPageMobile;
